export interface Comic {
  id: string;
  title: string;
  cover: string;
  genre: string;
  tags: string[];
  rating: number;
  hot: number;
  chapters: number;
  status: string;
  author: string;
  desc: string;
  updateInfo: string;
  intro: string;
}

export const categories = [
  { key: "rexue", name: "热血战斗", icon: "ri-flashlight-fill", desc: "燃到爆的拳拳到肉", count: 42 },
  { key: "kaigui", name: "开挂主角", icon: "ri-rocket-2-fill", desc: "出生即满级暴打全场", count: 36 },
  { key: "nixi", name: "逆袭流", icon: "ri-arrow-up-double-fill", desc: "废柴翻身打脸所有", count: 28 },
  { key: "longaotian", name: "龙傲天", icon: "ri-vip-crown-fill", desc: "天下无敌唯我独尊", count: 24 },
  { key: "dalian", name: "打脸爽文", icon: "ri-emotion-laugh-fill", desc: "扮猪吃虎装逼打脸", count: 31 },
  { key: "qiyue", name: "穿越逆袭", icon: "ri-sparkling-2-fill", desc: "穿越异界一路开挂", count: 20 },
];

export const comics: Comic[] = [
  {
    id: "fentian-zhanshen",
    title: "焚天战神",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20illustration%20of%20a%20fierce%20flame%20warrior%20wielding%20a%20giant%20flaming%20sword%2C%20roaring%20fire%20and%20burning%20embers%20around%20him%2C%20dark%20background%2C%20vibrant%20orange%20and%20red%20glow%2C%20dramatic%20dynamic%20pose%2C%20epic%20hot-blooded%20battle%20scene%2C%20manga%20art%20style&width=600&height=800&seq=cover-fentian&orientation=portrait",
    genre: "热血战斗",
    tags: ["热血", "战斗", "火系", "战神"],
    rating: 9.6,
    hot: 982000,
    chapters: 486,
    status: "连载中",
    author: "爆裂工作室",
    desc: "少年萧炎... 被废十年后觉醒焚天神脉，一柄火剑燃尽九重天，昔日欺辱他的宗门天骄，统统跪在他脚下喊老祖。",
    updateInfo: "今日 08:00 更新",
    intro: "被家族视为废物的萧炎，在悬崖下捡到一枚燃烧的古戒，就此觉醒焚天神脉。他凭着一股不服输的热血，从家族最底层一路烧穿宗门、王朝、圣域。每一场战斗都燃到极致，越级挑战、绝地反杀、火焚九天的名场面接踵而至。这是一部把「热血战斗」四个字写到骨子里的爽漫，火系战斗的想象力堪称一绝。",
  },
  {
    id: "wangu-jiandi",
    title: "万古剑帝",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20young%20swordsman%20emperor%20standing%20on%20a%20mountain%20of%20swords%2C%20glowing%20golden%20sword%20aura%2C%20dramatic%20clouds%2C%20dark%20fantasy%20style%2C%20intense%20gold%20lighting%2C%20manga%20illustration&width=600&height=800&seq=cover-wangu&orientation=portrait",
    genre: "开挂主角",
    tags: ["开挂", "剑修", "帝尊", "无敌"],
    rating: 9.4,
    hot: 915000,
    chapters: 412,
    status: "连载中",
    author: "青云漫社",
    desc: "万古剑帝转世重生，带着前世万年剑道记忆重新修炼。剑出，天地惊；万剑归宗，一剑破万法，同辈天骄见了他只能绕道走。",
    updateInfo: "昨日 20:30 更新",
    intro: "一位纵横万古的剑帝意外陨落，一缕残魂重生在宗门最不起眼的杂役弟子身上。他携前世剑道记忆，一路崛起，从杂役到内门，从内门到剑道之巅。别人修剑十载才入门，他一剑即可顿悟。开挂到极致的剑修爽漫，看着主角一路碾压同辈天骄，那种酣畅淋漓的爽感无可替代。",
  },
  {
    id: "cangqiong-po",
    title: "苍穹破",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20martial%20artist%20breaking%20through%20the%20sky%20with%20a%20massive%20energy%20blast%2C%20shattered%20clouds%20and%20rocks%2C%20deep%20night%20sky%20with%20orange%20fire%2C%20dynamic%20action%2C%20epic%20fantasy%20manga&width=600&height=800&seq=cover-cangqiong&orientation=portrait",
    genre: "逆袭流",
    tags: ["逆袭", "崛起", "玄幻", "热血"],
    rating: 9.2,
    hot: 868000,
    chapters: 358,
    status: "连载中",
    author: "破晓工作室",
    desc: "从人人可欺的废柴，到只手裂苍穹的强者。每一次绝境都是逆袭的开始，每一场嘲笑最后都变成打脸的巴掌。",
    updateInfo: "昨日 12:00 更新",
    intro: "出身寒微的林枫，因无法修炼被当成家族的笑柄。可他偏偏不信命，靠着一本残缺功法，硬生生从废柴堆里爬出来，一路逆袭，撕破重重天幕。这部漫画最爽的地方在于主角从不退缩，越是被人看不起，越要打脸打得响亮。逆袭流爱好者的必看之作。",
  },
  {
    id: "xiuluo-niming",
    title: "修罗逆命",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20demon-like%20overpowered%20hero%20with%20glowing%20red%20eyes%20and%20dark%20aura%2C%20holding%20a%20cursed%20blade%2C%20dark%20background%20with%20red%20flames%2C%20fierce%20expression%2C%20intense%20dark%20fantasy%20manga%20art&width=600&height=800&seq=cover-xiuluo&orientation=portrait",
    genre: "龙傲天",
    tags: ["龙傲天", "黑暗", "逆命", "无敌"],
    rating: 9.1,
    hot: 796000,
    chapters: 301,
    status: "连载中",
    author: "血月漫社",
    desc: "身负修罗血脉的少年，生来便是别人的噩梦。天道要灭他，他便逆天改命，把整个苍穹踩在脚下。",
    updateInfo: "今日 06:00 更新",
    intro: "修罗一族的末裔，天生携带毁天灭地的黑暗血脉，被整个大陆视为禁忌。但他从不向命运低头，一步步觉醒血脉，成为令所有人颤抖的存在。龙傲天设定的巅峰之作，暗黑热血风格独树一帜，主角的每一次爆发都能让人热血沸腾。",
  },
  {
    id: "xingyun-zhu",
    title: "星陨主宰",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20cosmic%20protagonist%20absorbing%20falling%20stars%2C%20galaxy%20nebula%20background%2C%20purple%20and%20gold%20energy%2C%20majestic%20powerful%20pose%2C%20epic%20space%20fantasy%20manga%20illustration&width=600&height=800&seq=cover-xingyun&orientation=portrait",
    genre: "热血战斗",
    tags: ["星辰", "宇宙", "热血", "主宰"],
    rating: 9.0,
    hot: 743000,
    chapters: 287,
    status: "连载中",
    author: "星河动漫",
    desc: "星空之子的觉醒，引动万星坠落。他以星辰为武器，战遍诸天万界，主宰星河，君临天下。",
    updateInfo: "昨日 18:00 更新",
    intro: "当第一颗星辰为他坠落，少年踏上了成为星界主宰的征途。整部漫画格局宏大，从一片大陆打到浩瀚星空，战斗场景瑰丽壮观。主角那种「以一人之力硬撼诸天」的热血气质，搭配星空的浪漫想象力，让这部作品在热血战斗类中独树一帜。",
  },
  {
    id: "wushang-shenguo",
    title: "无上神国",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20supreme%20emperor%20seated%20on%20a%20grand%20throne%20with%20golden%20light%20and%20floating%20palace%20in%20clouds%2C%20heavenly%20god%20aura%2C%20warm%20golden%20palette%2C%20majestic%20royal%20fantasy%20manga&width=600&height=800&seq=cover-wushang&orientation=portrait",
    genre: "龙傲天",
    tags: ["神国", "帝王", "龙傲天", "打脸"],
    rating: 9.3,
    hot: 812000,
    chapters: 356,
    status: "连载中",
    author: "神朝漫画",
    desc: "一朝觉醒神皇血脉，他重铸无上神国。昔日看不起他的世家贵女，如今排着队求他垂怜。",
    updateInfo: "今日 10:00 更新",
    intro: "被人踩进泥里的庶子，因一滴神皇之血而觉醒，从此一步登天，重建失落万年的无上神国。这部漫画把龙傲天和打脸爽文的爽点拉满，主角从被轻视到君临天下的过程一气呵成，看那些曾经高高在上的人跪地俯首，实在太过瘾。",
  },
  {
    id: "mieshi-kuangdao",
    title: "灭世狂刀",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20wild%20berserker%20warrior%20with%20a%20massive%20black%20greatsword%2C%20lightning%20and%20dark%20storm%20behind%2C%20intense%20red%20eyes%2C%20aggressive%20dynamic%20composition%2C%20dark%20fantasy%20battle%20manga&width=600&height=800&seq=cover-mieshi&orientation=portrait",
    genre: "热血战斗",
    tags: ["狂刀", "战斗", "黑暗", "爆发"],
    rating: 8.9,
    hot: 689000,
    chapters: 244,
    status: "连载中",
    author: "狂澜漫画",
    desc: "一柄灭世狂刀，斩碎万千敌寇。他狂，他野，他每一次挥刀都让天地为之色变。",
    updateInfo: "昨日 22:00 更新",
    intro: "身负狂刀的独行侠客，行事亦正亦邪，刀锋所指便是他狂意所向。这部作品的战斗场面极具张力，主角疯魔般的战斗风格让人看得血脉偾张。喜欢狂野硬核战斗风的读者，这部绝对不容错过。",
  },
  {
    id: "zhizun-danshi",
    title: "至尊炼丹师",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20an%20alchemist%20master%20refining%20a%20glowing%20pill%20with%20mystic%20flames%2C%20alchemy%20furnace%2C%20golden%20energy%20swirls%2C%20dark%20cave%20background%2C%20fantasy%20cultivation%20manga%20art&width=600&height=800&seq=cover-danshi&orientation=portrait",
    genre: "逆袭流",
    tags: ["炼丹", "逆袭", "丹道", "装逼"],
    rating: 8.8,
    hot: 634000,
    chapters: 268,
    status: "连载中",
    author: "丹青漫社",
    desc: "丹道至尊转世，随手炼出的丹药都是绝世珍品。别人求之不得的丹方，他闭着眼睛就能改良。",
    updateInfo: "今日 09:00 更新",
    intro: "上一世是丹道至尊，这一世回到起点。他随手炼出的丹药让各大宗门疯抢，随手改良的丹方让丹道宗师跪下求教。这部逆袭流爽漫的爽点在于主角靠「技术装逼」，一次次用丹道碾压那些看不起他的人，轻松又解压。",
  },
  {
    id: "shifang-leidi",
    title: "十方雷帝",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20thunder%20god%20summoning%20massive%20lightning%20bolts%2C%20stormy%20sky%2C%20electric%20lightning%20against%20dark%20clouds%2C%20powerful%20commanding%20pose%2C%20epic%20fantasy%20manga&width=600&height=800&seq=cover-leidi&orientation=portrait",
    genre: "开挂主角",
    tags: ["雷霆", "开挂", "雷帝", "无敌"],
    rating: 9.1,
    hot: 771000,
    chapters: 319,
    status: "连载中",
    author: "雷动漫画",
    desc: "天生雷体，万雷加身。他每渡一次天劫就强上一分，雷劫对他而言只是送经验的补品。",
    updateInfo: "昨日 16:00 更新",
    intro: "天生雷体的少年，生来就是雷霆的宠儿。别人渡劫九死一生，他渡劫等于开挂升级。这部开挂主角漫画把「天降异象、人人敬畏」的爽感拉满，主角一路引雷炼体、降妖除魔，战斗场面雷霆万钧、气势磅礴。",
  },
  {
    id: "shenji-qiandao",
    title: "神级签到系统",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20cocky%20young%20protagonist%20smirking%20while%20a%20golden%20holographic%20system%20panel%20floats%20beside%20him%2C%20floating%20treasure%20and%20light%2C%20modern%20fantasy%20manga%2C%20bright%20energetic%20style&width=600&height=800&seq=cover-qiandao&orientation=portrait",
    genre: "打脸爽文",
    tags: ["签到", "系统", "轻松", "装逼"],
    rating: 9.0,
    hot: 728000,
    chapters: 296,
    status: "连载中",
    author: "零二漫社",
    desc: "每天签个到，神功异宝白送到手。他本想低调做人，奈何实力不允许，随手装个逼就是全场最靓的仔。",
    updateInfo: "今日 07:00 更新",
    intro: "当别人还在苦修，主角已经靠「神级签到系统」躺赢。每天睁眼签个到，神功、异宝、美人排着队送上门。这部打脸爽文漫轻松解压，主角一本正经地装逼打脸，笑点密集，看完整个人都舒服了。适合饭后刷两话的轻松爽漫。",
  },
  {
    id: "hundun-shenghuang",
    title: "混沌圣皇",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20chaotic%20primordial%20emperor%20with%20swirling%20nebula%20and%20dragon%20silhouettes%20around%20him%2C%20dark%20cosmic%20background%2C%20red%20and%20gold%2C%20majestic%20overpowered%20aura%2C%20epic%20manga&width=600&height=800&seq=cover-hundun&orientation=portrait",
    genre: "龙傲天",
    tags: ["圣皇", "龙傲天", "混沌", "无敌"],
    rating: 9.2,
    hot: 755000,
    chapters: 342,
    status: "连载中",
    author: "混沌动漫",
    desc: "混沌圣皇回归，自带万古无敌气场。他走到哪里，哪里就是他的地盘，不服就打到服。",
    updateInfo: "昨日 14:00 更新",
    intro: "闭关万载的混沌圣皇一朝出关，发现整个天下已不识他名号。那就用拳头，让天下重新记起谁才是真正的圣皇。这部龙傲天漫画把「无人能敌」四个字发挥到极致，主角的强大从不需要解释，一路碾压的快感让人欲罢不能。",
  },
  {
    id: "wou-dushikaigui",
    title: "我在都市开挂",
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20stylish%20young%20man%20in%20modern%20city%20street%20with%20glowing%20cheat%20system%20halo%2C%20neon%20lights%20at%20night%2C%20cool%20confident%20smile%2C%20urban%20fantasy%20manga%20illustration&width=600&height=800&seq=cover-dushi&orientation=portrait",
    genre: "打脸爽文",
    tags: ["都市", "开挂", "系统", "打脸"],
    rating: 8.7,
    hot: 598000,
    chapters: 221,
    status: "连载中",
    author: "都市爆漫",
    desc: "普通社畜绑定都市开挂系统，从此商场、职场、情场全部通杀。看不起他的甲方，最后都成了他的小弟。",
    updateInfo: "今日 11:00 更新",
    intro: "一个被老板随意拿捏的打工人，突然绑定了都市开挂系统，人生从此逆风翻盘。这部都市打脸爽文漫贴近生活，主角用实力一次次打脸那些狗眼看人低的家伙，代入感极强，看得很解气。适合喜欢都市爽文的读者。",
  },
];

export interface RankItem {
  rank: number;
  comicId: string;
  trend: "up" | "down" | "flat";
}

// 热血战斗排行
export const hotRanking: RankItem[] = [
  { rank: 1, comicId: "fentian-zhanshen", trend: "up" },
  { rank: 2, comicId: "xingyun-zhu", trend: "up" },
  { rank: 3, comicId: "mieshi-kuangdao", trend: "flat" },
  { rank: 4, comicId: "shifang-leidi", trend: "up" },
  { rank: 5, comicId: "wangu-jiandi", trend: "down" },
  { rank: 6, comicId: "hundun-shenghuang", trend: "up" },
  { rank: 7, comicId: "cangqiong-po", trend: "flat" },
  { rank: 8, comicId: "wushang-shenguo", trend: "up" },
  { rank: 9, comicId: "xiuluo-niming", trend: "down" },
  { rank: 10, comicId: "zhizun-danshi", trend: "flat" },
];

// 热搜词
export const hotKeywords = [
  "开挂主角", "热血战斗", "逆袭流", "龙傲天", "打脸爽文", "穿越异界",
  "废柴逆袭", "无敌流", "都市开挂", "炼丹装逼", "雷霆炼体", "星辰战斗",
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "炮渣漫画网上的漫画可以免费阅读吗？",
    a: "是的，炮渣漫画网聚合的都是当前热度最高的无脑爽漫与热血战斗作品，平台提供快速试读与榜单推荐服务。你可以在详情页看到完整的简介、评分、热度与更新信息，方便按榜单直接开刷。如需完整章节，请前往对应漫画的正版平台支持作者。",
  },
  {
    q: "热血战斗排行多久更新一次？",
    a: "热血战斗排行每天自动更新一次，综合了热度、评分、更新频率和读者反馈等多个维度计算得出。我们会把表现突出的新作第一时间抬上榜，确保榜单永远反映当下最值得看的热血战斗漫画。",
  },
  {
    q: "什么是龙傲天、逆袭流、打脸爽文？",
    a: "简单说：龙傲天指主角天生无敌、一路碾压的设定；逆袭流指主角从低谷一步步翻身逆袭；打脸爽文则是主角扮猪吃虎、当众打脸反派的剧情。这些都是无脑爽漫里最受欢迎的爽点类型，炮渣漫画网专门为每种类型整理了对口合集。",
  },
  {
    q: "如何找到适合我的漫画类型？",
    a: "你可以通过顶部分类导航进入热血战斗、开挂主角、逆袭流、龙傲天、打脸爽文等专门频道，也可以直接在搜索框输入关键词（如\u201c炼丹\u201d\u201c都市\u201d）快速定位。每个漫画卡片都标注了完整标签，方便你精准挑片。",
  },
  {
    q: "可以自己投稿或推荐漫画吗？",
    a: "当然可以。如果你发现了一部很棒的开挂主角漫画或爽漫，欢迎通过联系我们页面留言，把作品名字和推荐理由告诉我们。我们的编辑会认真试看，如果质量过硬，就会把它收进对应的榜单或合集。",
  },
  {
    q: "榜单数据是怎么计算的？",
    a: "我们的榜单综合了多个维度：作品热度、读者评分、更新频率、口碑讨论和平台权威数据等。通过加权计算得出综合热度分，既保证客观，又能真实反映作品当前的火爆程度。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "热血小钢炮",
    role: "战斗漫重度读者",
    content: "不用翻来翻去找片了，炮渣漫画网的榜单太懂我了。焚天战神和星陨主宰直接冲榜首，每一部都燃到头皮发麻，一口气看了两百多话停不下来。",
  },
  {
    name: "躺平追漫人",
    role: "爽文爱好者",
    content: "专挑龙傲天和打脸爽文看，这里每部都踩在我的爽点上。分类超清楚，进去点开就能刷，再也不怕踩雷。",
  },
  {
    name: "逆袭流十年粉",
    role: "资深漫画读者",
    content: "编辑推荐的质量真的高，至尊炼丹师这种装逼流作品都能被挖出来。每天蹲更新已经成为习惯，这网站是逆袭流爱好者的宝藏。",
  },
];